'use client';

import { EU_DOMAINS } from 'helpers/constants/domains';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

const useLocale = () => {
  const [cookies, setCookie] = useCookies(['locale_selection']);
  const existingCookie = cookies?.locale_selection;

  const hostname = typeof window !== 'undefined' ? window?.location?.hostname : '';
  const isEuDomain = EU_DOMAINS?.includes(hostname);

  const expectedCurrency = isEuDomain ? 'EUR' : 'GBP';
  const expectedCountry = 'GB';

  // Parse and verify existing cookie
  let parsedLocale = { currency: expectedCurrency, countryCode: expectedCountry };

  try {
    parsedLocale = typeof existingCookie === 'string' ? JSON?.parse(existingCookie) : existingCookie || parsedLocale;
  } catch (e) {
    // fallback to expected
    parsedLocale = { currency: expectedCurrency, countryCode: expectedCountry };
  }
  useEffect(() => {
    const shouldReset =
      !existingCookie || parsedLocale?.currency !== expectedCurrency || parsedLocale?.countryCode !== expectedCountry;

    if (shouldReset) {
      setCookie('locale_selection', JSON?.stringify({ currency: expectedCurrency, countryCode: expectedCountry }));
    }
  }, [existingCookie, expectedCurrency, expectedCountry, setCookie]);

  const finalCurrency = parsedLocale?.currency !== expectedCurrency ? expectedCurrency : parsedLocale?.currency;
  const finalCountry = parsedLocale?.countryCode !== expectedCountry ? expectedCountry : parsedLocale?.countryCode;

  const getCurrency = () => finalCurrency;
  const getCountry = () => finalCountry;

  const locale = parsedLocale?.currency === 'GBP' ? 'en_GB' : 'en_EU';
  const ctLocale = 'en';
  const localeKey = locale?.replace('_', '-'); // 'en-GB' or 'en-EU'
  const fallbackLocale = 'en-GB';

  return { getCountry, getCurrency, locale, ctLocale, localeKey, fallbackLocale };
};

export default useLocale;
